export default __webpack_public_path__ + "static/media/icon.fb238042.svg";